import type { ElementType } from "react";

import { FoldersIcon } from "@hightouch/htui";

import type { AmpNavLink } from "src/components/layout/nav/sections/amp-nav-links";
import { PROJECTS_PATHS } from "src/pages/projects/constants";
import { NEW_FOLDER_ID } from "src/pages/projects/library/folder-paths";
import {
  DRAFTS_VIEW,
  LIBRARY_TOP_VIEWS,
  NEW_VIEW,
} from "src/pages/projects/library/library-filters";
import { selectLibraryFolder } from "src/pages/projects/library/use-library-list-filters";

type RailRowBase = {
  key: string;
  name: string;
  icon: ElementType;
  href: string;
};

/** A row of the Library's rail: a view it selects (`folderId` null for every file), or a page it opens. */
export type LibraryRailRow = RailRowBase &
  ({ kind: "view"; folderId: string | null } | { kind: "page" });

const viewHref = (folderId: string | null) => {
  if (folderId === NEW_FOLDER_ID) return PROJECTS_PATHS.libraryNew;
  if (folderId === null) return PROJECTS_PATHS.library;
  return `${PROJECTS_PATHS.library}?${selectLibraryFolder(new URLSearchParams(), folderId)}`;
};

const viewRow = ({
  id,
  name,
  icon,
}: {
  id: string | null;
  name: string;
  icon: ElementType;
}): LibraryRailRow => ({
  kind: "view",
  key: id ?? "all",
  folderId: id,
  name,
  icon,
  href: viewHref(id),
});

const VIEW_ROWS = [
  NEW_VIEW,
  // New work lands in Drafts, so it heads the files.
  DRAFTS_VIEW,
  { id: null, name: "Library", icon: FoldersIcon },
  ...LIBRARY_TOP_VIEWS,
].map(viewRow);

/** The Library rail's rows in order, which the palette lists under Content. */
export function libraryRailRows(
  catalogAdsLink: AmpNavLink | null,
): LibraryRailRow[] {
  return catalogAdsLink
    ? [
        ...VIEW_ROWS,
        {
          kind: "page",
          key: catalogAdsLink.href,
          name: catalogAdsLink.label,
          icon: catalogAdsLink.icon,
          href: catalogAdsLink.href,
        },
      ]
    : VIEW_ROWS;
}
